<div class="flex flex-col">
  <div
    (click)="openWorkOfArtModal(item)"
    class="relative cursor-pointer aspect-square w-full rounded-2xl overflow-hidden group"
  >
    <!-- Skeleton mientras carga -->
    @if (!loadedImages.has(item._id)) {
    <div class="absolute inset-0 bg-gray-200 animate-pulse"></div>
    }

    <!-- Imagen -->
    <img
      [ngSrc]="item.image"
      width="600"
      height="600"
      loading="lazy"
      (load)="onThumbnailLoad(item._id)"
      [class.opacity-0]="!loadedImages.has(item._id)"
      [class.opacity-100]="loadedImages.has(item._id)"
      [alt]="item.title"
      class="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
    />

    <!-- Icono Destacado -->
    @if (item.labels?.includes('featured')) {
    <div
      class="absolute top-2 right-2 w-7 h-7 bg-yellow-200 rounded-full flex items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-3 h-3 rotate-[-90deg]"
        fill="currentColor"
        viewBox="0 0 448 512"
      >
        <path
          d="M268.3 24.1c-9.7-24.6-45-24.6-54.6 0L162.2 150.1 28.2 171.4c-26.3 4-36.8 36.1-17.7 54.6L116 312.6 89.5 448c-4.5 25.5 22.4 44.9 45.1 33L224 375.5 313.4 481c22.7 11.9 49.6-7.5 45.1-33L332 312.6 437.5 226c19.1-18.5 8.6-50.6-17.7-54.6L285.8 150.1 268.3 24.1z"
        />
      </svg>
    </div>
    }

    <!-- Badge OFERTA -->
    @if (
      item.salePrice &&
      item.salePrice > 0 &&
      item.salePrice < item.price &&
      !item.labels?.includes('sold')
    ) {
    <span
      class="absolute top-2 left-2 rounded bg-red-500 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white shadow-sm"
    >
      Oferta
    </span>
    }

    <!-- Badge de Categoría con blur -->
    <span
      class="absolute bottom-2 left-2 text-white text-xs px-2 py-0.5 rounded bg-black/50 backdrop-blur-sm"
    >
      {{ item.category.name }}
    </span>
  </div>

  <!-- Título -->
  <p class="mt-2 text-sm font-medium text-black leading-tight">
    {{ item.title }}
  </p>
</div>
